module.exports = __webpack_public_path__ + "static/media/p1a2.e8f7d157.wav";